"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_icons_1 = require("./fabric-icons");
var fabric_icons_0_1 = require("./fabric-icons-0");
var fabric_icons_1_1 = require("./fabric-icons-1");
var fabric_icons_2_1 = require("./fabric-icons-2");
var fabric_icons_3_1 = require("./fabric-icons-3");
var fabric_icons_4_1 = require("./fabric-icons-4");
var fabric_icons_5_1 = require("./fabric-icons-5");
var fabric_icons_6_1 = require("./fabric-icons-6");
var fabric_icons_7_1 = require("./fabric-icons-7");
var fabric_icons_8_1 = require("./fabric-icons-8");
var fabric_icons_9_1 = require("./fabric-icons-9");
var fabric_icons_10_1 = require("./fabric-icons-10");
var fabric_icons_11_1 = require("./fabric-icons-11");
require("./icon-aliases");
var DEFAULT_BASE_URL = 'https://static2.sharepointonline.com/files/fabric/assets/icons/';
function initializeIcons(baseUrl) {
    if (baseUrl === void 0) { baseUrl = DEFAULT_BASE_URL; }
    [fabric_icons_1.initializeIcons, fabric_icons_0_1.initializeIcons, fabric_icons_1_1.initializeIcons, fabric_icons_2_1.initializeIcons, fabric_icons_3_1.initializeIcons, fabric_icons_4_1.initializeIcons, fabric_icons_5_1.initializeIcons, fabric_icons_6_1.initializeIcons, fabric_icons_7_1.initializeIcons, fabric_icons_8_1.initializeIcons, fabric_icons_9_1.initializeIcons, fabric_icons_10_1.initializeIcons, fabric_icons_11_1.initializeIcons].forEach(function (initialize) { return initialize(baseUrl); });
}
exports.initializeIcons = initializeIcons;
var IconNames_1 = require("./IconNames");
exports.IconNames = IconNames_1.IconNames;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uifabric/icons/lib/index.js
// module id = ../node_modules/@uifabric/icons/lib/index.js
// module chunks = 1